export const BASE_AUTH_PATH = "auth";

export const AUTH_ROUTES = {
  LOGIN: "login",
  CHECK_EMAIL: "check-email",
  CREATE_NEW_PASSWORD: "create-new-password",
  CREATE_NEW_PASSWORD_SUCCESS: "create-new-password-success",
  CONFIRM_SIGN_IN: "confirm-sign-in",
  FORGOT_PASSWORD: "forgot-password",
  MFA_SETUP: "mfa-setup",
  SSO_LOGIN: "sso-login",
  SSO_SIGN_OUT: "sso-sign-out",
};
